import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';

export default function ResetPassword() {
  const [formData, setFormData] = useState({
    token: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);
  // Nuevo estado para los mensajes en pantalla
  const [status, setStatus] = useState({ type: '', msg: '' });
  const navigate = useNavigate();

  const handleReset = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus({ type: '', msg: '' }); // Limpiar mensajes previos

    try {
      await api.post('/users/reset-password', formData);
      
      setStatus({ 
        type: 'success', 
        msg: '🎉 ¡Contraseña cambiada! Redirigiendo al login...' 
      });

      // Redirigir después de 2 segundos para que el usuario vea el mensaje
      setTimeout(() => navigate('/login'), 2500);
      
    } catch (err) {
      const errorMsg = err.response?.data?.message || 'Código incorrecto o expirado';
      setStatus({ 
        type: 'error', 
        msg: `❌ ${errorMsg}` 
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-indigo-600 to-purple-700 p-4">
      <div className="bg-white p-8 rounded-2xl shadow-2xl w-full max-w-md">
        <h2 className="text-3xl font-bold text-gray-800 text-center mb-2">Restablecer</h2>
        <p className="text-gray-500 text-center text-sm mb-6">Ingresa el código de 6 dígitos enviado a tu correo.</p>

        <form onSubmit={handleReset} className="space-y-6">
          {/* MENSAJE DE ESTADO (Éxito o Error) */}
          {status.msg && (
            <div className={`p-3 rounded-lg text-sm font-medium text-center animate-bounce ${
              status.type === 'success' 
                ? 'bg-green-100 text-green-700 border border-green-200' 
                : 'bg-red-100 text-red-700 border border-red-200'
            }`}>
              {status.msg}
            </div>
          )}

          <div>
            <label className="block text-xs font-bold text-gray-400 uppercase mb-1 ml-1">Código de Seguridad</label>
            <input
              type="text"
              maxLength="6"
              placeholder="Ej: OJ4SO8"
              className="w-full px-4 py-4 border-2 border-dashed border-gray-300 rounded-xl focus:border-indigo-500 focus:ring-0 outline-none text-center text-2xl font-black tracking-[0.5em] uppercase text-indigo-600"
              value={formData.token}
              onChange={(e) => setFormData({ ...formData, token: e.target.value.toUpperCase() })}
              required
            />
          </div>

          <div>
            <label className="block text-xs font-bold text-gray-400 uppercase mb-1 ml-1">Nueva Contraseña</label>
            <input
              type="password"
              placeholder="••••••••"
              className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500 outline-none transition"
              value={formData.password}
              onChange={(e) => setFormData({ ...formData, password: e.target.value })}
              required
              minLength={6}
            />
          </div>

          <button
            disabled={loading || status.type === 'success'}
            className="w-full bg-indigo-600 text-white py-3 rounded-xl font-bold hover:bg-indigo-700 disabled:bg-gray-400 transition shadow-lg flex justify-center items-center"
          >
            {loading ? (
              <>
                <svg className="animate-spin h-5 w-5 mr-3 text-white" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Validando...
              </>
            ) : 'Cambiar Contraseña'}
          </button>
        </form>
      </div>
    </div>
  );
}